import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  snackbar: {
    backgroundColor: theme?.snackbar?.backgroundColor,
    color: theme?.snackbar?.color,
  }
}));

export default useStyles;